/* /src/routes/privateRoute.jsx */
import React from "react";
import { Route } from "react-router-dom";
import * as services from './projects/services';
import { AuthConsumer } from "../providers/authProvider";

export const PrivateRoute = ({ component, ...rest }) => {
    const renderFn = (Component) => (props) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect, signoutRedirectCallback,logout }) => {
                if (!!Component && isAuthenticated()) {
                    if (!localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')) {
                        let ajaxdata = services.GetAjaxUserClaims();
                        if (!!ajaxdata) {
                            if (ajaxdata.status === 0) {
                                localStorage.setItem('QUANREN_SSO_MM_USER_CACHE', JSON.stringify(ajaxdata.result));
                            } else if (ajaxdata.message === '还未登录') {
                                signoutRedirectCallback();
                                return <span>loading</span>;
                            }
                        }
                    }
                    return <Component {...props} logout={logout}  />;
                } else {
                    signinRedirect();
                    return <span>loading</span>;
                }
            }
            }
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
};